// 聖杯牌組 (Suit of Cups) - 14張
// 使用 Wikipedia Commons 官方圖庫
const cupsImages = {
  1: 'https://upload.wikimedia.org/wikipedia/commons/3/36/Cups01.jpg',
  2: 'https://upload.wikimedia.org/wikipedia/commons/f/f8/Cups02.jpg',
  3: 'https://upload.wikimedia.org/wikipedia/commons/7/7a/Cups03.jpg',
  4: 'https://upload.wikimedia.org/wikipedia/commons/0/0f/Cups04.jpg',
  5: 'https://upload.wikimedia.org/wikipedia/commons/d/d7/Cups05.jpg',
  6: 'https://upload.wikimedia.org/wikipedia/commons/1/17/Cups06.jpg',
  7: 'https://upload.wikimedia.org/wikipedia/commons/a/ae/Cups07.jpg',
  8: 'https://upload.wikimedia.org/wikipedia/commons/6/60/Cups08.jpg',
  9: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Cups09.jpg',
  10: 'https://upload.wikimedia.org/wikipedia/commons/8/84/Cups10.jpg',
  11: 'https://upload.wikimedia.org/wikipedia/commons/a/ad/Cups11.jpg',
  12: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Cups12.jpg',
  13: 'https://upload.wikimedia.org/wikipedia/commons/6/62/Cups13.jpg',
  14: 'https://upload.wikimedia.org/wikipedia/commons/0/04/Cups14.jpg'
};

export const cups = [
  {
    id: 'c1',
    name: '聖杯一',
    nameEn: 'Ace of Cups',
    img: cupsImages[1],
    upright: {
      keywords: ['愛', '直覺', '新感情', '情緒流動'],
      meaning: '這是一個情感豐沛的新開始。可能是新戀情、新友誼,或是內心深處某種自我療癒與愛的覺醒。'
    },
    reversed: {
      keywords: ['情感壓抑', '空虛', '自我封閉'],
      meaning: '你可能正在壓抑自己的真實感受,或者覺得內心有一種無法被填補的空虛感。'
    }
  },
  {
    id: 'c2',
    name: '聖杯二',
    nameEn: 'Two of Cups',
    img: cupsImages[2],
    upright: {
      keywords: ['結合', '伴侶', '互相吸引', '和諧'],
      meaning: '代表著兩顆心的真誠交流與結合。這是一段平等、和諧且充滿互相理解的關係。'
    },
    reversed: {
      keywords: ['失衡', '溝通不良', '分手'],
      meaning: '關係中可能出現了不平等的狀態,或者是彼此之間產生了誤解與隔閡。'
    }
  },
  {
    id: 'c3',
    name: '聖杯三',
    nameEn: 'Three of Cups',
    img: cupsImages[3],
    upright: {
      keywords: ['友誼', '慶祝', '社交', '互助'],
      meaning: '這是一個歡樂的時刻!與志同道合的朋友聚在一起,分享喜悅,享受人際關係帶來的溫暖。'
    },
    reversed: {
      keywords: ['孤立', '過度放縱', '流言蜚語'],
      meaning: '可能在社交中感到被排擠,或者因為過度沉溺於聚會玩樂而忽略了正事。'
    }
  },
  {
    id: 'c4',
    name: '聖杯四',
    nameEn: 'Four of Cups',
    img: cupsImages[4],
    upright: {
      keywords: ['倦怠', '冷淡', '沉思', '錯失良機'],
      meaning: '你似乎對現狀感到有些無聊或不滿,甚至忽略了宇宙正遞給你的新機會。試著睜開眼睛看看周圍。'
    },
    reversed: {
      keywords: ['重新參與', '抓住機會', '走出低潮'],
      meaning: '你正在從情緒的低谷中走出來,準備好重新接納世界,接受新的可能性。'
    }
  },
  {
    id: 'c5',
    name: '聖杯五',
    nameEn: 'Five of Cups',
    img: cupsImages[5],
    upright: {
      keywords: ['悲傷', '失落', '遺憾', '沉溺過去'],
      meaning: '你正專注於已經失去的東西而感到悲傷。請轉過身看看,其實你還有保留下來的美好事物。'
    },
    reversed: {
      keywords: ['接受現實', '走出傷痛', '原諒'],
      meaning: '你開始接受了失去的現實,準備放下過去的遺憾,重新開始你的生活。'
    }
  },
  {
    id: 'c6',
    name: '聖杯六',
    nameEn: 'Six of Cups',
    img: cupsImages[6],
    upright: {
      keywords: ['回憶', '童真', '懷舊', '純粹的善意'],
      meaning: '過去的美好回憶或故人可能會再次出現。這是一張充滿純真、溫暖與無條件分享的牌。'
    },
    reversed: {
      keywords: ['沉溺過去', '拒絕長大', '不切實際'],
      meaning: '你可能過度美化了過去,導致無法專注於現在的挑戰。是時候向前看了。'
    }
  },
  {
    id: 'c7',
    name: '聖杯七',
    nameEn: 'Seven of Cups',
    img: cupsImages[7],
    upright: {
      keywords: ['幻想', '選擇障礙', '白日夢', '誘惑'],
      meaning: '你的面前有很多選擇,看起來都很誘人,但其中混雜著虛幻的泡沫。請保持清醒,看清現實。'
    },
    reversed: {
      keywords: ['看清現實', '做出決定', '幻想破滅'],
      meaning: '迷霧正在散去,你終於看清了什麼才是真實且可行的,並準備做出明確的決定。'
    }
  },
  {
    id: 'c8',
    name: '聖杯八',
    nameEn: 'Eight of Cups',
    img: cupsImages[8],
    upright: {
      keywords: ['追尋', '離開', '放下', '探索內心'],
      meaning: '雖然現狀並不壞,但你內心深處知道這不是你真正想要的。你決定轉身離開,去尋找更高的精神滿足。'
    },
    reversed: {
      keywords: ['害怕改變', '安於現狀', '無處可逃'],
      meaning: '你明明知道這段關係或環境已經不再適合你,卻因為害怕未知而遲遲不敢離開。'
    }
  },
  {
    id: 'c9',
    name: '聖杯九',
    nameEn: 'Nine of Cups',
    img: cupsImages[9],
    upright: {
      keywords: ['滿足', '願望成真', '享受', '得意'],
      meaning: '這被稱為「願望牌」。你的願望即將實現,內心充滿了滿足感與幸福感,好好享受這份快樂吧。'
    },
    reversed: {
      keywords: ['貪婪', '物質滿足但內心空虛', '願望落空'],
      meaning: '雖然表面上擁有了一切,但內心卻依然覺得少了些什麼;或者你的願望以意想不到的方式落空了。'
    }
  },
  {
    id: 'c10',
    name: '聖杯十',
    nameEn: 'Ten of Cups',
    img: cupsImages[10],
    upright: {
      keywords: ['家庭', '和諧', '幸福', '終極的滿足'],
      meaning: '這代表著情感上的最高境界。與心愛的人之間有著深厚的連結,生活充滿了平靜與完美的和諧。'
    },
    reversed: {
      keywords: ['家庭衝突', '關係破裂', '表面和平'],
      meaning: '家庭或親密關係中可能出現了裂痕,表面上的和諧掩蓋了真實的衝突與不滿。'
    }
  },
  {
    id: 'c11',
    name: '聖杯侍者',
    nameEn: 'Page of Cups',
    img: cupsImages[11],
    upright: {
      keywords: ['敏感', '想像力', '新消息', '創意'],
      meaning: '你內心柔軟且充滿想像力,可能會收到關於感情或創意的好消息。保持這份純真的感受力。'
    },
    reversed: {
      keywords: ['情緒化', '逃避現實', '不成熟'],
      meaning: '你可能變得過度敏感、情緒化,或者因為無法面對現實而躲進了自己的幻想世界裡。'
    }
  },
  {
    id: 'c12',
    name: '聖杯騎士',
    nameEn: 'Knight of Cups',
    img: cupsImages[12],
    upright: {
      keywords: ['浪漫', '理想主義', '追求夢想', '魅力'],
      meaning: '你帶著浪漫的理想與熱情前進,這是一個充滿魅力、聽從內心指引去追尋愛的時期。'
    },
    reversed: {
      keywords: ['喜怒無常', '不切實際', '花心'],
      meaning: '浪漫可能變成了不切實際的幻想,或者在情感中顯得喜怒無常、難以承擔真實的責任。'
    }
  },
  {
    id: 'c13',
    name: '聖杯皇后',
    nameEn: 'Queen of Cups',
    img: cupsImages[13],
    upright: {
      keywords: ['同理心', '直覺', '溫柔', '情感支持'],
      meaning: '你如同水一般包容,擁有強大的同理心與直覺。這是一個提供療癒與溫暖支持的強大角色。'
    },
    reversed: {
      keywords: ['情緒勒索', '過度依賴', '失去界線'],
      meaning: '你可能因為過度吸收他人的情緒而讓自己崩潰,或者在關係中失去了健康的心理界線。'
    }
  },
  {
    id: 'c14',
    name: '聖杯國王',
    nameEn: 'King of Cups',
    img: cupsImages[14],
    upright: {
      keywords: ['情緒穩定', '寬容', '成熟的愛', '智慧'],
      meaning: '你擁有深厚的情感,但不會被情緒所淹沒。這代表著一種成熟、穩定且充滿智慧的掌控力。'
    },
    reversed: {
      keywords: ['冷漠', '掌控情緒', '操縱'],
      meaning: '你可能為了保護自己而變得冷漠,或者利用你對人性的了解去暗中操縱他人的情感。'
    }
  }
];